import { render } from "./TemplateSurvey.vue?vue&type=template&id=67a35e4c&scoped=true"
import script from "./TemplateSurvey.vue?vue&type=script&lang=js"
export * from "./TemplateSurvey.vue?vue&type=script&lang=js"

import "./TemplateSurvey.vue?vue&type=style&index=0&id=67a35e4c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-67a35e4c"

export default script